/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'ecommerce/005-fast delivery': {
    width: 512,
    height: 512,
    viewBox: '0 0 512.001 512.001',
    data: '<path pid="0" d="M474.662 105H226.937c-18.97 0-34.915 14.218-37.09 33.073l-26.205 227.294C161.089 387.521 178.421 407 200.731 407h247.725c18.97 0 34.915-14.218 37.09-33.073l26.205-227.294C514.304 124.48 496.973 105 474.662 105zm-94.114 30l-7.545 53.692h-55.944L324.604 135zm101.4 8.198l-26.205 227.293a7.34 7.34 0 01-7.287 6.509H200.731c-4.402 0-7.788-3.846-7.286-8.197L219.65 141.51a7.34 7.34 0 017.287-6.509h67.371l-9.359 66.605c-1.267 9.029 5.753 17.087 14.854 17.087h86.239a15 15 0 0014.854-12.913l9.945-70.78h63.819c4.404 0 7.79 3.846 7.288 8.198zM119.983 305.107H15c-8.284 0-15 6.716-15 15s6.716 15 15 15h104.983c8.284 0 15-6.716 15-15s-6.715-15-15-15zM119.983 241.107H31.979c-8.284 0-15 6.716-15 15s6.716 15 15 15h88.004c8.284 0 15-6.716 15-15s-6.715-15-15-15zM119.983 177.107H47.98c-8.284 0-15 6.716-15 15s6.716 15 15 15h72.003c8.284 0 15-6.716 15-15s-6.715-15-15-15z"/>'
  }
})
